import { render, staticRenderFns } from "./AppDataFilterCheckboxGroupChildItem.vue?vue&type=template&id=a2d4a97e&scoped=true&"
import script from "./AppDataFilterCheckboxGroupChildItem.vue?vue&type=script&lang=js&"
export * from "./AppDataFilterCheckboxGroupChildItem.vue?vue&type=script&lang=js&"
import style0 from "./AppDataFilterCheckboxGroupChildItem.vue?vue&type=style&index=0&id=a2d4a97e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d4a97e",
  null
  
)

export default component.exports